import React from "react";
import Payment from "../../assets/payments.png";
import "./Footer.scss";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <>
      <footer className=" bg-gray-100 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-7 gap-2">
            <div className="1">
              <h3 className="text-sm font-bold mb-4">Important Link</h3>
              <ul className="list-none list-inside text-gray-700 text-sm cursor-pointer">
                <li
                  onClick={() => navigate("/privacy-policy")}
                  className="text"
                >
                  Privacy Policy
                </li>
                <li
                  onClick={() => navigate("/customer-policy")}
                  className="text"
                >
                  Customer Policy
                </li>
                <li onClick={() => navigate("/disclaimer")} className="text">
                  Disclaimer
                </li>
                <li onClick={() => navigate("/faqs")} className="text">
                  FAQs
                </li>
                <li
                  onClick={() => navigate("/cancellation-policy")}
                  className="text"
                >
                  Cancellation Policy
                </li>
                <li onClick={() => navigate("/refund-policy")} className="text">
                  Refund Policy
                </li>
                <li
                  onClick={() => navigate("/shippingPolicy")}
                  className="text"
                >
                  Shipping Policy
                </li>
                <li
                  onClick={() => navigate("/TermsAndConditions")}
                  className="text"
                >
                  Terms And Conditions
                </li>
                <li onClick={() => navigate("/aboutus")} className="text">
                  About us
                </li>
                <li onClick={() => navigate("/login")} className="text">
                  Create Account
                </li>
              </ul>
            </div>
            <div className="1 md:col-span-2   w-full text-center ">
              <h3 className="text-md font-bold mb-4 text-left ">
                Shop spare parts and accessories{" "}
              </h3>
              <div className="flex justify-left items-center text-left gap-10 md:gap-2 ">
                <ul className="list-none list-inside text-gray-700 text-sm cursor-pointer lowercase">
                  <li>
                    <Link to="/category/shop-by-bike">Shop By Bike</Link>
                  </li>
                  <li>
                    <Link to="/category/bike-protection">BIKE PROTECTION</Link>
                  </li>
                  <li>
                    <Link to="/category/bike-essentials">BIKE ESSENTIALS</Link>
                  </li>
                  <li>
                    <Link to="/category/handle-bars-accessories">
                      Handle Bars & Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/lightning">Lightning</Link>
                  </li>
                  <li>
                    <Link to="/category/performance-accessories">
                      Performance Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/body-fairing-fenders">
                      Body Fairing & Fenders
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/foot-controls">Foot Controls</Link>
                  </li>
                  <li>
                    <Link to="/category/cleaning-accessories">
                      Cleaning Accessories
                    </Link>
                  </li>
                </ul>

                <ul className="list-none list-inside text-gray-700 text-sm cursor-pointer lowercase">
                  <li>
                    <Link to="/category/car-body-covers">CAR BODY COVERS</Link>
                  </li>
                  <li>
                    <Link to="/category/car-horns">CAR HORNS</Link>
                  </li>
                  <li>
                    <Link to="/category/door-visors">DOOR VISORS</Link>
                  </li>
                  <li>
                    <Link to="/category/chrome-accessories">
                      CHROME ACCESSORIES
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/blind-spot-mirrors">
                      BLIND SPOT MIRRORS
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/door-guards">DOOR GUARDS</Link>
                  </li>
                  <li>
                    <Link to="/category/bumper-protectors">
                      BUMPER PROTECTORS
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/fog-lamps">Fog Lamps</Link>
                  </li>
                  <li>
                    <Link to="/category/halogen-bulbs">Halogen Bulbs</Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="1 md:col-span-2   w-full text-center ">
              <h3 className="text-md font-bold mb-4 text-left ">
                Shop bike accessories by category
              </h3>
              <div className="flex justify-left items-center text-left gap-10 md:gap-2 ">
                <ul className="list-none list-inside text-gray-700 text-sm cursor-pointer lowercase">
                  <li>
                    <Link to="/category/shop-by-bike">Shop By Bike</Link>
                  </li>
                  <li>
                    <Link to="/category/bike-protection">BIKE PROTECTION</Link>
                  </li>
                  <li>
                    <Link to="/category/bike-essentials">BIKE ESSENTIALS</Link>
                  </li>
                  <li>
                    <Link to="/category/handle-bars-accessories">
                      Handle Bars & Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/lightning">Lightning</Link>
                  </li>
                  <li>
                    <Link to="/category/performance-accessories">
                      Performance Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/body-fairing-fenders">
                      Body Fairing & Fenders
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/foot-controls">Foot Controls</Link>
                  </li>
                  <li>
                    <Link to="/category/cleaning-accessories">
                      Cleaning Accessories
                    </Link>
                  </li>
                </ul>

                <ul className="list-none list-inside text-gray-700 text-sm cursor-pointer lowercase">
                  <li>
                    <Link to="/category/wheel-accessories">
                      Wheel Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/rider-protection">
                      Rider Protection
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/casuals">Casuals</Link>
                  </li>
                  <li>
                    <Link to="/category/bags-backpacks">Bags & Backpacks</Link>
                  </li>
                  <li>
                    <Link to="/category/touring-accessories">
                      Touring Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/luggage-accessories">
                      Luggage Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/carriers-backrest">
                      Carriers & Backrest
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/helmet-accessories">
                      Helmet Accessories
                    </Link>
                  </li>
                  <li>
                    <Link to="/category/accessories">Accessories</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className=" md:col-span-2 w-full   flex flex-col gap-5">
              <div className=" flex  gap-2">
                <div className="1 text-sm">
                  <h3 className="text-md font-bold mb-2">
                    Registered Office Address
                  </h3>
                  <p className="text-gray-700">
                    CYNOR INDIA <br />
                    RZ-2/161, 1st Floor, Street No. 6A <br />
                    Durga Park, Palam <br />
                    New Delhi -110045
                  </p>
                </div>
                <div className="1 text-sm">
                  <h3 className="text-md font-bold mb-2">Warehouse Address</h3>
                  <p className="text-gray-700">
                    CYNOR INDIA <br />
                    Plot No. 7, Street No. 15B <br />
                    Prem Vihar, Nangli Sakrawati <br />
                    Najafgarh, New Delhi-110043
                  </p>
                </div>
              </div>
              <div>
                <h1 className="text-sm font-bold mb-4 text-center md:text-left">
                  For any queries and support,connect us.
                </h1>
                <div className=" flex  justify-evenly md:justify-between">
                  <div className=" text-sm">support@carizo.in</div>
                  <div className=" text-sm">98100-21158</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="border-t border-gray-100 py-4">
        <div className="flex flex-col items-center gap-4 md:flex-row md:justify-between md:items-center mx-auto max-w-screen-xl px-4">
          <span className="flex gap-5 cursor-pointer text-2xl md:text-2xl list-none">
            <li className="text-blue-700">
              <ion-icon name="logo-facebook"></ion-icon>
            </li>
            <li className="text-red-700">
              <ion-icon name="logo-google"></ion-icon>
            </li>
            <li className="text-blue-500">
              <ion-icon name="logo-twitter"></ion-icon>
            </li>
            <li className="text-red-600">
              <ion-icon name="logo-youtube"></ion-icon>
            </li>
            <li className="text-purple-700">
              <ion-icon name="logo-instagram"></ion-icon>
            </li>
          </span>
          <span className="text-sm md:text-sm text-gray-500">
            © 2020 All Rights Reserved by Bestwebcreator
          </span>
          <img src={Payment} alt="Payment methods" className="md:h-5" />
        </div>
      </div>
    </>
  );
};

export default Footer;
